import NavBar from './NavBar.vue';

import withUser from '../../hoc/withUser';

export default withUser()(NavBar);
